export default __webpack_public_path__ + "static/media/BG-Green-0006.303cb08f.png";